<div [class]="'loader-animation size-' + size"></div>
